// Property type factories used to build appearance editors
import { StrokeType, FillType, FontType, TextType } from "../PropertyTypes";

// Anotações (Annotations) category - includes text annotations and coordinate tools
const anotacoesRegistry = {
  displayName: "Anotações",
  interactives: {
    interactiveText: {
      displayName: "Anotação",
      key: "interactiveText",
      icon: "Text_Annotation",
      propName: "textList",
      component: "InteractiveText",
      defaultOptionsForAppearance: [
        TextType({
          name: "text",
          displayName: "Texto",
          defaultValue: "Lorem ipsum...",
        }),
        FontType({
          name: "font",
          displayName: "Fonte",
          defaultValue: {
            fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
            color: "#FF5722",
            fontSize: 12,
          },
        }),
        FillType({
          name: "bgFill",
          displayName: "Fundo",
          defaultValue: { color: "#FFFFFF", opacity: 0 },
        }),
      ],
    },
    arrow: {
      displayName: "Seta",
      key: "arrow",
      icon: "Shape_Arrow",
      propName: "arrows",
      component: "Arrow",
      defaultOptionsForAppearance: [
        StrokeType({
          name: "stroke",
          displayName: "Cor da Borda",
          defaultValue: {
            color: "#2196F3",
            dash: "Solid",
            width: 2,
            opacity: 1,
          },
        }),
        FillType({
          name: "fill",
          displayName: "Preenchimento",
          defaultValue: { color: "#2196F3", opacity: 0.7 },
        }),
      ],
    },
    callout: {
      displayName: "Balão de Texto",
      key: "callout",
      icon: "Callout",
      propName: "callouts",
      component: "Callout",
      defaultOptionsForAppearance: [
        TextType({ name: "text", displayName: "Texto", defaultValue: "Texto" }),
        StrokeType({
          name: "stroke",
          displayName: "Cor da Borda",
          defaultValue: {
            color: "#000000",
            dash: "Solid",
            width: 1,
            opacity: 1,
          },
        }),
        FillType({
          name: "fill",
          displayName: "Preenchimento",
          defaultValue: { color: "#FFFFFF", opacity: 0.9 },
        }),
        FontType({
          name: "font",
          displayName: "Fonte",
          defaultValue: {
            fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
            color: "#000000",
            fontSize: 12,
          },
        }),
      ],
      appearance: {
        r: 6, // drag handle radius
      },
    },
    // DISABLED: InteractiveYCoordinate - Comentado temporariamente
    /* interactiveYCoordinate: {
            displayName: 'Interactive Y Coordinate',
            key: 'interactiveYCoordinate',
            icon: 'Crosshair',
            propName: 'yCoordinateList',
            component: 'InteractiveYCoordinate',
            defaultOptionsForAppearance: [
                FontType({ name: 'font', displayName: 'Fonte', defaultValue: { fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif', color: '#607D8B', fontSize: 12 } }),
                StrokeType({ name: 'stroke', displayName: 'Cor da Linha', defaultValue: { color: '#607D8B', dash: 'ShortDash2', width: 2, opacity: 1 } }),
                FillType({ name: 'bgFill', displayName: 'Cor do Fundo', defaultValue: { color: '#FFFFFF', opacity: 1 } }),
            ]
        } */
  },
};

export default anotacoesRegistry;
